import React, {useEffect, useState} from 'react'
import FetchUtil from "../../../../util/FetchUtil";
import ConfigUtil from "../../../../util/ConfigUtil";

/**
 * Lädt die beendeten Spiele eines Spielers im Event. games ist undefined solange geladen wird.
 */
export function useSpieleDesSpielers(tournamentId, playerId) {
    const [games, setGames] = useState(undefined);
    const [fehler, setFehler] = useState(undefined);
    const aktiv = tournamentId !== null && tournamentId !== undefined && playerId !== null && playerId !== undefined;

    useEffect(() => {
        if (!aktiv) {
            return;
        }
        setGames(undefined);
        setFehler(undefined);
        const url = ConfigUtil.getConfig().resourceUrls.public + "/tournamentgames/" + tournamentId + "/" + playerId;
        FetchUtil.fetchGet(url,
            json => setGames(json),
            responseNotOk => setFehler("Fehler beim Laden der Spiele: " + responseNotOk.message),
            error => setFehler("Fehler beim Laden der Spiele: " + error.message));
    }, [aktiv, tournamentId, playerId]);

    return {aktiv, games, fehler};
}

/**
 * Gespielte Spiele eines Spielers im neuen Design, gruppiert nach Phase. Ersetzt in der neuen Ansicht
 * den StatistikGamesDialog; ein Klick auf ein Spiel ruft onSpielWaehlen auf (Spieldetails).
 */
export default function SpieleListe({games, fehler, onSpielWaehlen}) {

    // wie bisher: mit Gruppenphase getrennt nach Gruppenphase und KO/DKO-Phase, sonst nur "Spiele"
    const getGruppen = () => {
        const gruppenphase = games.filter(game => game.gruppenphase);
        const ko = games.filter(game => !game.gruppenphase);
        const gruppen = [];
        if (gruppenphase.length > 0) {
            gruppen.push({titel: "Gruppenphase", spiele: gruppenphase});
        }
        if (ko.length > 0) {
            gruppen.push({titel: gruppenphase.length > 0 ? "KO/DKO-Phase" : "Spiele", spiele: ko});
        }
        return gruppen;
    }

    // Ergebnis kommt aus der Gamestatistik und fehlt bei Spielen ohne Statistik
    const hatErgebnis = (game) => game.spieler1Anzahl !== null && game.spieler1Anzahl !== undefined
        && game.spieler2Anzahl !== null && game.spieler2Anzahl !== undefined;

    const spieler = (spielerId, spielerName, game) => {
        const gewonnen = game.gewonnenPlayerId === spielerId;
        return <span className={"dhpt-sl-spieler" + (gewonnen ? " dhpt-sl-sieger" : "")}>
            {gewonnen && <><i className="pi pi-check-circle dhpt-gd-gewinner-icon" aria-hidden="true"/><span className="dhpt-st-versteckt">Gewinner: </span></>}
            {spielerName}
        </span>;
    }

    if (fehler) {
        return <p className="dhpt-hinweis dhpt-gd-fehler" role="alert">{fehler}</p>;
    }
    if (games === undefined) {
        return <p className="dhpt-hinweis">Spiele werden geladen …</p>;
    }
    if (games.length === 0) {
        return <p className="dhpt-hinweis">Es sind noch keine beendeten Spiele vorhanden.</p>;
    }
    return getGruppen().map(gruppe => <section key={gruppe.titel} className="dhpt-karte dhpt-sl">
        <h3 className="dhpt-karte-titel">
            <span>{gruppe.titel}</span>
            <span className="dhpt-karte-zusatz">{gruppe.spiele.length} {gruppe.spiele.length === 1 ? "Spiel" : "Spiele"}</span>
        </h3>
        <ul className="dhpt-sl-liste">
            {gruppe.spiele.map(game => <li key={game.id}>
                <button type="button" className="dhpt-sl-spiel" onClick={() => onSpielWaehlen(game)}
                        aria-label={"Spieldetails " + game.spieler1Name + " gegen " + game.spieler2Name
                            + (hatErgebnis(game) ? ", " + game.spieler1Anzahl + " zu " + game.spieler2Anzahl + (game.setModus ? " Sets" : " Legs") : "")}>
                    {spieler(game.spieler1Id, game.spieler1Name, game)}
                    {hatErgebnis(game)
                        ? <span className="dhpt-sr-stand" title={game.setModus ? "Sets" : "Legs"}>{game.spieler1Anzahl}:{game.spieler2Anzahl}</span>
                        : <span className="dhpt-sl-vs" aria-hidden="true">vs.</span>}
                    {spieler(game.spieler2Id, game.spieler2Name, game)}
                    <i className="pi pi-chevron-right dhpt-sl-pfeil" aria-hidden="true"/>
                </button>
            </li>)}
        </ul>
    </section>);
}
